import { severityInfo } from '@locales/id/labels';
import type { Severity } from '@lib/api';
import { Chip } from '@ui';

export function SeverityChip({ severity }: { severity: Severity }) {
  const s = severityInfo(severity);
  return <Chip tone={s.tone}>{s.label}</Chip>;
}
